import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {TscThemeName, TscThemeNames, TscStyles, Spinner} from '@techsmith/tsc-cloud-style-guide';
import {StyledWarning} from '../util/StyledElements';
import withMemoizedContexts from '../../context/contextContainerHoC';
import {themeStore} from '../../context/themeProvider';

const LoadingSpinner = styled.div<{theme: TscThemeNames}>`
   position: absolute;
   display: flex;
   align-items: center;
   top: -0.5rem;
   bottom: -0.5rem;
   left: -0.5rem;
   right: -0.5rem;
   z-index: 3;
   opacity: .9;
   background: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.ui.dusk.medium : TscStyles.color.ui.dawn.light};
`;

const TabBody = styled.div`
   position: relative;
   margin: 1.5rem 1.25rem 1.25rem;
`;

export const TabContentWrapperBase: React.FC<ITabContentWrapperProps & IStateMappedProps> = ({children, showSpinner, showError, customErrorMessage, theme}) => {
   const {t} = useTranslation();

   return (
      <TabBody>
         {showError && <StyledWarning>{customErrorMessage ? customErrorMessage : t('general.errorText')}</StyledWarning>}
         {children}
         {showSpinner && <LoadingSpinner theme={theme}><Spinner themeName={theme} /></LoadingSpinner>}
      </TabBody>
   );
};

export interface ITabContentWrapperProps {
   children?: React.ReactNode;
   showSpinner: boolean;
   showError: boolean;
   customErrorMessage?: string;
}

export interface IStateMappedProps {
   theme: TscThemeNames;
}

const mapStatesToProps = (
   {children, showSpinner, showError, customErrorMessage}: ITabContentWrapperProps,
   {theme}: Partial<IStateMappedProps>
): ITabContentWrapperProps & IStateMappedProps => ({children, showSpinner, showError, customErrorMessage, theme});

export default withMemoizedContexts(mapStatesToProps, themeStore)(TabContentWrapperBase);
